import { Progress } from '@mantine/core'
import ProgressClasses from './styles.module.css'

export default Progress.extend({
    defaultProps: { radius: 'xl', size: 'md' },
    classNames: ProgressClasses,
})
